export const DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_500_ERROR_MESSAGE = 'Сервер не отвечает';